export type Tab = 'queue' | 'drafts' | 'published' | 'feeder' | 'topsellers';
export type FeederSubTab = 'manual' | 'categories' | 'discover' | 'scouts' | 'tendencias' | 'publish';

export const QUEUE_STATUS_MAP: Record<string, 'ok' | 'warning' | 'error' | 'info' | 'unknown'> = {
  pending: 'warning',
  enriching: 'info',
  ready: 'ok',
  published: 'ok',
  skipped: 'unknown',
  error: 'error',
  out_of_stock: 'error',
  pre_order: 'warning',
  review: 'warning',
  closed: 'unknown',
  paused: 'unknown',
};

export const DRAFT_STATUS_MAP: Record<string, 'ok' | 'warning' | 'error' | 'info' | 'unknown'> = {
  draft: 'info',
  approved: 'ok',
  published: 'ok',
  closed: 'unknown',
  rejected: 'error',
  error: 'error',
};

export const SITE_FLAGS: Record<string, string> = {
  MLA: '\u{1F1E6}\u{1F1F7}',
  MLM: '\u{1F1F2}\u{1F1FD}',
  MLC: '\u{1F1E8}\u{1F1F1}',
  MCO: '\u{1F1E8}\u{1F1F4}',
  MLU: '\u{1F1FA}\u{1F1FE}',
  MLB: '\u{1F1E7}\u{1F1F7}',
};
